import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const PdfViewerModal = ({ show, onHide, pdfUrl, fileName, rutaArchivo }) => {
  const getDownloadUrl = () => {
    if (!rutaArchivo) return null;
    const API_URL = process.env.REACT_APP_API_URL || 'https://apiprov.conduto.com.ec';
    return `${API_URL}/api/documentos/visualizar/${rutaArchivo}?download=true`;
  };

  const downloadUrl = getDownloadUrl();

  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="bi bi-file-earmark-pdf text-danger me-2"></i>
          {fileName || "Vista previa del PDF"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ height: '70vh' }}>
        {pdfUrl ? (
          <iframe
            src={pdfUrl}
            title="PDF Preview"
            width="100%"
            height="100%"
            style={{ border: 'none' }}
          />
        ) : (
          <div className="text-center py-5">
            <i className="bi bi-file-earmark-x display-1 text-muted"></i>
            <p className="mt-3 text-muted">No hay archivo para previsualizar</p>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cerrar
        </Button>
        {downloadUrl && (
          <Button
            variant="primary"
            href={downloadUrl}
            download
          >
            <i className="bi bi-download me-1"></i>
            Descargar
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default PdfViewerModal;